import { request } from '@/utils/request.js';
import { clearStorage } from '@/utils/storage.js';

/**
 * 侧边栏/历史记录功能 Mixin
 * 包含：侧边栏开关、历史会话列表、会话详情、结束对话、退出登录
 */
export default {
    data() {
        return {
            sidebarShow: false, // 侧边栏是否展开
            sidebarLoading: false, // 侧边栏是否加载中
            sidebarConversations: [], // 侧边栏会话列表
            sidebarShowDetail: false, // 是否显示历史详情弹窗
            sidebarDetailMessages: [], // 历史详情消息列表
            sidebarShowEndDialog: false, // 是否显示结束对话弹窗
        };
    },

    methods: {
        // 打开侧边栏并加载会话列表
        sidebarToggle() {
            this.sidebarShow = true;
            this.sidebarLoadConversations();
        },

        // 关闭侧边栏
        sidebarClose() {
            this.sidebarShow = false;
        },

        // 加载侧边栏会话列表（过滤掉当前进行中的会话）
        async sidebarLoadConversations() {
            this.sidebarLoading = true;
            try {
                const res = await request({
                    url: '/api/conversations',
                    method: 'GET',
                });
                if (res.data.code === 200) {
                    const list = res.data.data.conversations || [];
                    this.sidebarConversations = this.chatConversationId
                        ? list.filter(
                              (c) =>
                                  c.conversationId !== this.chatConversationId
                          )
                        : list;
                }
            } catch (e) {
                console.error('加载会话列表失败:', e);
            } finally {
                this.sidebarLoading = false;
            }
        },

        // 查看某个会话的详情
        async sidebarViewConversation(item) {
            try {
                const res = await request({
                    url: `/api/conversations/${item.conversationId}/messages`,
                    method: 'GET',
                });
                if (res.data.code === 200) {
                    this.sidebarDetailMessages = res.data.data.messages || [];
                    this.sidebarShowDetail = true;
                }
            } catch (e) {
                console.error('加载会话详情失败:', e);
                this.$toast('加载失败');
            }
        },

        // 跳转到报告页面
        sidebarViewReport(item) {
            this.sidebarClose();
            this.$router.push(`/report?conversationId=${item.conversationId}`);
        },

        // 格式化日期为 MM-DD HH:mm
        sidebarFormatDate(dateStr) {
            if (!dateStr) return '';
            const d = new Date(dateStr);
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hour = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${month}-${day} ${hour}:${min}`;
        },

        // 直接结束对话（不生成报告），并开启新对话
        async sidebarHandleEndOnly() {
            this.sidebarShowEndDialog = false;
            this.audioStop();
            this.chatStopTypewriter();
            if (this.chatThinkingTimer) {
                clearTimeout(this.chatThinkingTimer);
                clearInterval(this.chatThinkingTimer);
                this.chatThinkingTimer = null;
            }
            if (this.chatConversationId) {
                try {
                    await request({
                        url: '/api/end-conversation',
                        method: 'POST',
                        data: { conversationId: this.chatConversationId },
                    });
                } catch (e) {
                    console.error('标记会话结束失败:', e);
                }
            }
            this.chatConversationId = '';
            this.messages = [];
            this.chatShowDefaultWelcome();
            this.$toast('已开启新对话');
        },

        // 结束对话并跳转到报告页
        async sidebarHandleEndWithReport() {
            const realMessages = this.messages.filter(
                (m) => m.type !== 'thinking'
            );
            if (realMessages.length < 5) {
                this.$toast('对话内容太少，无法生成总结报告');
                return;
            }
            const cid = this.chatConversationId;
            this.sidebarShowEndDialog = false;
            if (cid) {
                try {
                    await request({
                        url: '/api/end-conversation',
                        method: 'POST',
                        data: { conversationId: cid },
                    });
                } catch (e) {
                    console.error('标记会话结束失败:', e);
                }
            }
            this.chatConversationId = '';
            this.messages = [];
            this.$router.push(`/report?conversationId=${cid}`);
        },

        // 退出登录：弹窗确认后清除登录状态并跳转门户页
        async sidebarHandleLogout() {
            try {
                await this.$dialog.confirm({
                    title: '提示',
                    message: '确定要退出登录吗？',
                });
            } catch (e) {
                return; // 用户取消
            }
            if (this.chatConversationId) {
                try {
                    await request({
                        url: '/api/end-conversation',
                        method: 'POST',
                        data: { conversationId: this.chatConversationId },
                    });
                } catch (e) {
                    console.error('标记会话结束失败:', e);
                }
            }
            if (this.audioRecordTimer) {
                clearInterval(this.audioRecordTimer);
            }
            if (this.chatTypingTimer) {
                clearInterval(this.chatTypingTimer);
            }
            if (this.chatThinkingTimer) {
                clearTimeout(this.chatThinkingTimer);
                clearInterval(this.chatThinkingTimer);
            }
            this.audioStop();
            clearStorage();
            this.$toast({ message: '已退出登录', duration: 1500 });
            setTimeout(() => {
                this.$router.replace('/portal');
            }, 1500);
        },
    },
};
